import { CardBrandEnum } from './model';

/**
 * Map card brand enum to logo asset path.
 * Logo assets exist in projects/payment/src/assets/img/
 *
 * Note: For brands without dedicated logos, returns generic card icon.
 */
export function getCardLogoPath(brand: CardBrandEnum | null): string {
  if (!brand) {
    return 'assets/img/card-generic.svg'; // Placeholder for unknown
  }

  const logoMap: Record<CardBrandEnum, string> = {
    [CardBrandEnum.VISA]: 'assets/img/visa.png',
    [CardBrandEnum.MASTERCARD]: 'assets/img/master.png',
    [CardBrandEnum.AMERICANEXPRESS]: 'assets/img/amex.png',
    [CardBrandEnum.DINERSCLUB]: 'assets/img/diners.png',
    [CardBrandEnum.DISCOVER]: 'assets/img/discover.png',
    [CardBrandEnum.JCB]: 'assets/img/jcb.png',
    [CardBrandEnum.ELO]: 'assets/img/elo.png',
    [CardBrandEnum.HIPERCARD]: 'assets/img/hipercard.png',
    [CardBrandEnum.HIPER]: 'assets/img/hiper.png',
    // Brands without local assets - use generic
    [CardBrandEnum.MAESTRO]: 'assets/img/card-generic.svg',
    [CardBrandEnum.UNIONPAY]: 'assets/img/card-generic.svg',
    [CardBrandEnum.DANKORT]: 'assets/img/card-generic.svg',
    [CardBrandEnum.FORBRUGSFORENINGEN]: 'assets/img/card-generic.svg',
  };

  return logoMap[brand] ?? 'assets/img/card-generic.svg';
}

/**
 * Get CVV max length for a card brand.
 * Amex uses 4-digit CVV, all others use 3.
 */
export function getCvvMaxLength(brand: CardBrandEnum | null): number {
  if (brand === CardBrandEnum.AMERICANEXPRESS) {
    return 4;
  }
  return 3;
}
